import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
import { SupplierDto } from './supplier.dto';
import { SupplierDeliveryHoursDto } from './supplierDeliveryHours.dto';
import { IsBoolean, IsNumber, IsOptional } from "class-validator";

export class SupplierDeliveryDto extends BaseDto {
  supplierId: number;
  merchantId: number;
  orderContactName: string;
  orderContactEmail: string;
  orderEmail: string;
  requestEmail:string;
  orderContactPhone: string;
  accountNumber: string;
  supplierEdiCode: string;
  reocurringOrders: boolean;
  sendOrderstoContactEmail: boolean;
  emailCreditNoteRequests: boolean;
  emailReturnNoteRequests: boolean;
  enableForm: boolean;
  surchargeEnabled: boolean;
  flatSurcharge: number;
  percentageSurcharge: number;
  supplier?: SupplierDto;
  merchant?: MerchantDto;
  supplierDeliveryHours?: SupplierDeliveryHoursDto[];
  isEnabledForPOSystem?: boolean
}
